export const maximumRefreshAttempts = 1;

export function getAuthSettings() {
  const baseUrl = import.meta.env.VITE_APP_AUTH_BASE_URL as string;
  const { origin } = window.location;

  return {
    changePasswordUrl: `${baseUrl}/change-password`,
    clientId: import.meta.env.VITE_APP_AUTH_CLIENT_ID as string,
    clientSecret: import.meta.env.VITE_APP_AUTH_CLIENT_SECRET as string,

    callbackUrl: `${origin}/auth`,
    callbackLogoutUrl: `${origin}/logout`,

    checkUrl: `${baseUrl}/api/check`,
    authorizeUrl: `${baseUrl}/oauth/authorize`,
    tokenUrl: `${baseUrl}/oauth/token`,
    logoutUrl: `${baseUrl}/logout`,
    scope: import.meta.env.VITE_APP_AUTH_SCOPE as string,
  };
}
